import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ModuleLoader } from '@wix/thunderbolt-symbols'
import { ESMLoaderSymbol } from 'feature-builder-module-loader'
import type { IBuilderModuleLoader } from './types'

/** Client-side module loader adapter — delegates to the ESM loader */
export const ClientBuilderModuleLoader = withDependencies(
	[ESMLoaderSymbol],
	({ loadModule }: ModuleLoader): IBuilderModuleLoader => ({ loadModule })
)
